/**
 * store.ts —— 极简可订阅状态容器
 *
 * 为什么不用第三方状态库：本项目只需要「可变引擎实例 + 少量 UI 状态」的订阅通知，
 * 用 React 18 的 useSyncExternalStore 直接接一个 12 行的 store 即可，
 * 同时天然避开 StrictMode 双调用带来的定时器重复调度问题（调度逻辑全在 React 之外）。
 */

export interface Store<T> {
  get(): T;
  set(next: T | ((prev: T) => T)): void;
  subscribe(listener: () => void): () => void;
}

export function createStore<T>(initial: T): Store<T> {
  let value = initial;
  const listeners = new Set<() => void>();
  return {
    get: () => value,
    set(next) {
      const v = typeof next === 'function' ? (next as (p: T) => T)(value) : next;
      if (v === value) return;
      value = v;
      for (const l of [...listeners]) l();
    },
    subscribe(l) {
      listeners.add(l);
      return () => listeners.delete(l);
    },
  };
}
